import ProtectedRoute from "routes/ProtectedRoute";
import { protectedRouteLoader } from "routes/loaders/protectedRouteLoader";

export const settingsRoutes = [
  {
    path: "setting",
    loader: protectedRouteLoader,
    lazy: async () => {
      const [layoutMod, errorMod] = await Promise.all([
        import("components/UI/AdminLayout"),
        import("views/ErrorPage"),
      ]);
      const AdminLayout = layoutMod.default;
      const ErrorPage = errorMod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
    children: [
      {
        path: "account-setting",
        lazy: async () => {
          const mod = await import(
            "views/Admin/Settings/NavSetting/account-setting"
          );
          const Page = mod.NavAccountSetting;
          return { Component: Page };
        },
      },
      {
        path: "billing",
        lazy: async () => {
          const mod = await import("views/Admin/Settings/NavSetting/billing");
          const Page = mod.NavBilling;
          return { Component: Page };
        },
      },
      {
        path: "team-setting",
        lazy: async () => {
          const mod = await import(
            "views/Admin/Settings/NavSetting/team-settings"
          );
          const Page = mod.TeamSettings;
          return { Component: Page };
        },
      },
      {
        path: "projector-requests",
        lazy: async () => {
          const mod = await import("views/projector/request");
          const Page = mod.ProjectorRequests;
          return { Component: Page };
        },
      },
      {
        path: "apps",
        lazy: async () => {
          const mod = await import(
            "views/Admin/Settings/NavSetting/SettingsApps"
          );
          const Page = mod.default;
          return { Component: Page };
        },
      },
      {
        path: "feedback-questions",
        lazy: async () => {
          const mod = await import(
            "views/Admin/Settings/NavSetting/feedback-question-settings"
          );
          const Page = mod.FeedbackQuestionSettings;
          return { Component: Page };
        },
      },
    ],
  },
];
